import { useState } from "react";
import {
  OutlinedInput,
  Button,
  Menu,
  MenuItem,
  InputAdornment,
} from "@material-ui/core";
import CheckIcon from "@mui/icons-material/Check";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function InputBonusMeta({
  value,
  onChange,
  type,
  onTypeChange,
  disabled = false,
  width = 160,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => setAnchorEl(null);

  const handleSelect = (newType) => {
    onTypeChange(newType);
    setAnchorEl(null);
  };

  const formatValue = (val) => {
    if (!val || val === "") return "";
    const numValue = parseFloat(val.toString().replace(",", "."));
    if (isNaN(numValue)) return val;
    
    if (numValue < 0.001) {
      return "0,001";
    }
    
    return numValue.toFixed(3).replace(".", ",");
  };

  const handleChange = (e) => {
    let inputValue = e.target.value;
    
    const regex = type === "V" ? /[^0-9.,]/g : /[^0-9,]/g;
    inputValue = inputValue.replace(regex, "");
    
    inputValue = inputValue.replace(".", ",");
    
    const parts = inputValue.split(",");
    if (parts.length > 2) {
      inputValue = parts[0] + "," + parts.slice(1).join("");
    }
    
    if (parts.length === 2 && parts[1].length > 3) {
      inputValue = parts[0] + "," + parts[1].substring(0, 3);
    }
    
    onChange({ target: { value: inputValue } });
  };

  const handleBlur = (e) => {
    const formatted = formatValue(e.target.value);
    if (formatted !== e.target.value) {
      onChange({ target: { value: formatted } });
    }
  };

  return (
    <>
      <OutlinedInput
        value={value || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        style={{ width }}
        inputProps={{ style: { textAlign: "right" } }}
        disabled={disabled}
        startAdornment={
          <InputAdornment style={{ position: 'absolute', left: 0 }}>
            <Button
              size="small"
              onClick={(e) => setAnchorEl(e.currentTarget)}
              disabled={disabled}
              endIcon={<ArrowDropDownIcon fontSize="small" />}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#90A4AE",
                backgroundColor: "#e9ecef",
                textTransform: "none",
                height: "45px",
              }}
            >
              {type === "V" ? "R$" : "%"}
            </Button>
          </InputAdornment>
        }
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        style={{ marginTop: 50 }}
      >
        <MenuItem
          onClick={() => handleSelect("V")}
          style={{
            display: "flex",
            justifyContent: "space-between",
            minWidth: 140,
          }}
        >
          R$ Valor
          {type === "V" && <CheckIcon fontSize="small" />}
        </MenuItem>
        <MenuItem
          onClick={() => handleSelect("P")}
          style={{
            display: "flex",
            justifyContent: "space-between",
            minWidth: 140,
          }}
        >
          % Percentual
          {type === "P" && <CheckIcon fontSize="small" />}
        </MenuItem>
      </Menu>
    </>
  );
}
